import React from 'react';

import DarkModeIcon from '@mui/icons-material/DarkMode';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import { Box, ListItemText, Switch } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { logoutActions } from 'common/utils/helpers/session';

import StyledMenuItem from './StyledMenuItem';

const ProfileMenuItems = ({
    handleCloseProfileMenu,
    match,
    profileValues,
    redirect,
    selectedTheme,
    setTheme,
}) => {
    const { t } = useTranslation();
    const handleOnSwitchTheme = (e) => {
        const theme = e.target.checked ? 'dark' : 'light';
        setTheme(theme);
    };

    return (
        <>
            <StyledMenuItem
                onClick={() => {
                    handleCloseProfileMenu();
                    redirect('/profile');
                }}
                selected={match.path === '/profile'}
            >
                <PersonIcon />
                <ListItemText
                    primary={`${profileValues?.first_name} ${profileValues?.last_name}`}
                />
            </StyledMenuItem>
            <Box hidden>
                <StyledMenuItem>
                    <DarkModeIcon />
                    <ListItemText primary={t('Dark mode')} />
                    <Switch
                        checked={selectedTheme === 'dark'}
                        onChange={handleOnSwitchTheme}
                    />
                </StyledMenuItem>
            </Box>
            <StyledMenuItem
                onClick={() => {
                    handleCloseProfileMenu();
                    logoutActions();
                }}
            >
                <LogoutIcon />
                <ListItemText primary={t('Logout')} />
            </StyledMenuItem>
        </>
    );
};

ProfileMenuItems.propTypes = {
    handleCloseProfileMenu: PropTypes.func,
    match: PropTypes.object,
    profileValues: PropTypes.object,
    redirect: PropTypes.func,
    selectedTheme: PropTypes.string,
    setTheme: PropTypes.func,
};

export default ProfileMenuItems;
